import React from 'react';
import classNames from 'classnames';
import statusSmallIcon_blue from 'static/images/icon/statusSmallIcon_blue.png';
import statusSmallIcon_warning from 'static/images/icon/statusSmallIcon_warning.png';
import statusSmallIcon_danger from 'static/images/icon/statusSmallIcon_danger.png';
import statusSmallIcon_none from 'static/images/icon/statusSmallIcon_none.png';

import { GrWifi, GrWifiMedium, GrWifiLow, GrWifiNone } from 'react-icons/gr';

const StatusTable = ({ data }) => {
  const a = (status, typeStatus) => {
    if (status === 'none' || status === 'off') {
      return status;
    }

    return typeStatus;
  };

  const convertRssiToImg = (rssi) => {
    if (Number(rssi) >= -100) {
      return <GrWifi />;
    } else if (Number(rssi) <= -101 && Number(rssi) >= -110) {
      return <GrWifiMedium />;
    } else if (Number(rssi) <= -111 && Number(rssi) >= -120) {
      return <GrWifiLow />;
    }

    return <GrWifiNone />;
  };

  return (
    <div>
      <table>
        <tbody>
          <tr className="module-status-value-tr">
            <td className={classNames('area-status-td')}>
              { (!data.fwVersion && data.statusCode === '1' && data.status !== 'none') || (!!data.fwVersion && data.relayFlag !== 0 && data.status !== 'none') ? ( //data.relayFlag !== 0 && data.status !== 'none'
                <img height="30" src={statusSmallIcon_blue} alt={`${data.modelNm}-icon`} />
              ) : data.status === 'danger' ? (
                <img height="30" src={statusSmallIcon_danger} alt={`${data.modelNm}-icon`} />
              ) : data.status === 'warning' ? (
                <img height="30" src={statusSmallIcon_warning} alt={`${data.modelNm}-icon`} />
              ) : data.status === 'none' ? (
                <img height="30" src={statusSmallIcon_none} alt={`${data.modelNm}-icon`} />
              ) : (
                <img height="30" src={statusSmallIcon_blue} alt={`${data.modelNm}-icon`} />
              )}
            </td>
            {(!data.fwVersion && data.statusCode === '1') || (!!data.fwVersion && data.relayFlag !== 0) ?  data.status !== 'none' ? ( //data.relayFlag !== 0 ?  data.status !== 'none'
              <>
                <td className={classNames('area-name-td', 'blue')}>{data.areaNo}</td>
                <td className={classNames('area-name-td', 'blue')}>{data.areaNm}</td>
                <td className={classNames('area-name-td', 'blue')}>{data.modelNm}</td>
                <td className={classNames('repeater-td', 'blue')} colSpan={5}>
                  Repeater
                </td>
                <td className={classNames('repeater-rssi-td', 'blue')}>{convertRssiToImg(data.rssi)}</td>
              </>
            ) : (<>
                  <td className={classNames('area-name-td', 'none')}>{data.areaNo}</td>
                  <td className={classNames('area-name-td', 'none')}>{data.areaNm}</td>
                  <td className={classNames('area-name-td', 'none')}>{data.modelNm}</td>
                  <td className={classNames('repeater-td', 'none')} colSpan={5}>
                    Repeater
                  </td>
                  <td className={classNames('repeater-rssi-td', 'none')}>{convertRssiToImg(data.rssi)}</td>
                </>) :
            (
              <>
                <td className={classNames('area-name-td', data.status)}>{data.areaNo}</td>
                <td className={classNames('area-name-td', data.status)}>{data.areaNm}</td>
                <td className={classNames('area-name-td', data.status)}>{data.modelNm}</td>
                <td className={classNames(data.status, data.o2_status+'-text')}>{Number(data['o2']).toFixed(1)}</td>
                <td className={classNames(data.status, data.co2_status+'-text')}>{data['co2']}</td>
                <td className={classNames(data.status, data.h2s_status+'-text')}>{data['h2s']}</td>
                <td className={classNames(data.status, data.co_status+'-text')}>{data['co']}</td>
                <td className={classNames(data.status, data.hc_status+'-text')}>{data['hc']}</td>
                <td className={classNames(data.status, data.hc_status+'-text')}>{convertRssiToImg(data.rssi)}</td>
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StatusTable;
